import { render } from "./PickupPointActionMenu.vue?vue&type=template&id=5065a0f0&scoped=true"
import script from "./PickupPointActionMenu.vue?vue&type=script&lang=js"
export * from "./PickupPointActionMenu.vue?vue&type=script&lang=js"

import "./PickupPointActionMenu.vue?vue&type=style&index=0&id=5065a0f0&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5065a0f0"]])

export default __exports__